export class Contact {
  phone?: string;
  email?: string;
  optin?: boolean;

  constructor(phone?: string, email?: string, optin?: boolean) {
    this.phone = phone;
    this.email = email;
    this.optin = optin;
  }

  isValid() {
    return this.phone != null || this.email != null || this.optin != null;
  }
}
